<template>
  <div>
    <template v-if="!isMobile" ref="scrollComponent">
      <div
        class="match-wrapper"
        :class="{
          fav: type === 'homeFavList',
          last: type === 'homeFavList' && index === matchList.length - 1,
          split: type === 'fav',
        }"
        v-for="(o, index) in matchList"
        :key="index"
        v-show="!isLoading && !isShowNoData"
      >
        <template v-if="type === 'fav'">
          <div
            class="display-flex-align-center home-match__title-wrapper capitalize home-match-fav-title"
          >
            {{ o.matchDate }}
          </div>

          <template v-for="l in o.leagueMatchList" :key="l.leagueId">
            <router-link
              :to="{
                path: `/${currentLocale}/${currentSportType}/${l.countryKey}/${l.leagueKey}`,
                query: {
                  leagueId: l.leagueId,
                  subLeagueId: l.subLeagueId,
                },
              }"
              class="display-flex-align-center home-match__title-wrapper"
            >
              <leagueIcon
                :icon="l.leagueKey"
                className="mr-05rem icon-league home-match__league_icon"
              >
                <img
                  :src="`${s3ImgUrl}/${l.logo}`"
                  class="home-match__league_icon"
                />
              </leagueIcon>
              <div>
                <div class="home-match__title home-match-country">
                  {{ l.country }}
                </div>
                <div class="display-flex-align-center">
                  <div class="home-match__title" v-if="l.leagueName !== null">
                    {{ l.leagueName }}
                  </div>
                  <!-- <div
                    v-if="l.isFavLeague"
                    class="icon-fav small"
                    :class="{ 'has-subleague-fav': !!l.subLeagueName }"
                  ></div> -->
                  <div class="home-match__title" v-if="!!l.subLeagueName">
                    : {{ l.subLeagueName }}
                  </div>
                </div>

                <!-- <div class="ml-s">
                  <svg
                    width="6"
                    height="10"
                    viewBox="0 0 6 10"
                    class="home-match__title-icon"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.334961 8.46017L3.57913 5.20892L0.334961 1.95767L1.33371 0.958923L5.58371 5.20892L1.33371 9.45892L0.334961 8.46017Z"
                    />
                  </svg>
                </div> -->
              </div>
            </router-link>

            <!-- v-for="(level2, index) in type === 'homeFavList' ? favMatchList(o.matchList) : o.matchList" -->

            <router-link
              :to="{
                path: `/${currentLocale}/${currentSportType}/${
                  l.countryKey ?? countryKey
                }/${l.leagueKey ?? leagueKey}/${
                  level2.opponents[0].name.replace(/(\s|\/)/g, '-') +
                  '-vs-' +
                  level2.opponents[1].name.replace(/\s|\//g, '-')
                }/${level2.matchId}`,
              }"
              class="match-container"
              :class="{
                'fav-match-container': type === 'homeFavList',
              }"
              v-for="(level2, index) in l.matchList"
              :key="index"
            >
              <div
                class="home-match__score-card__wrapper"
                :class="{
                  'live-selected': level2.isLive,
                  'rounded-right': noOdd,
                }"
              >
                <div class="home-match__1-wrapper">
                  <div
                    class="display-flex home-match__1-container"
                    :key="index"
                  >
                    <!-- <div class="display-flex-sb flex-1 h-100"> -->
                    <div class="home-match__status">
                      <span
                        v-show="type === 'team' && level2.matchState !== 0"
                        v-html="statusWithoutComma(level2.matchStatus)"
                      ></span>
                      <span
                        v-show="type !== 'team' && level2.matchState !== 0"
                        >{{ statusWithoutComma(level2.matchStatus) }}</span
                      >
                    </div>
                    <div class="match-detail">
                      <div class="match-detail__team-container">
                        <div class="icon-league">
                          <span
                            class="penalty-compact-label right"
                            v-if="level2.opponents[0].penaltyWin"
                            >P</span
                          >
                          <img
                            :src="`${s3ImgUrl}/${level2.opponents[0].logo}`"
                          />
                          <span class="team-fav-icon-right">
                            <FavStarIcon
                              v-if="level2.opponents[0].isFavTeam"
                              starType="small"
                            />
                          </span>
                        </div>
                        <div class="match-detail__name">
                          {{ level2.opponents[0].name }}
                        </div>
                      </div>
                    </div>
                    <!-- </div> -->

                    <div class="match-score-or-time-section fav-time-section">
                      <div
                        v-if="
                          level2.matchState !== 0 &&
                          !['Postp.', 'TBA'].includes(level2.matchStatus)
                        "
                        :class="[
                          level2.opponents[0].redCard < 1 &&
                          level2.opponents[1].redCard < 1
                            ? 'match-score-or-time__pad-for-red-card'
                            : 'team-red-card-section',
                        ]"
                      >
                        <div class="team-red-card-container">
                          <template v-if="level2.opponents[0].redCard >= 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in 3"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                          <template v-else-if="level2.opponents[0].redCard < 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in level2.opponents[0].redCard"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                        </div>
                        <div class="team-red-card-container">
                          <template v-if="level2.opponents[1].redCard >= 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in 3"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                          <template v-else-if="level2.opponents[1].redCard < 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in level2.opponents[1].redCard"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                        </div>
                      </div>

                      <div
                        v-if="['Postp.', 'TBA'].includes(level2.matchStatus)"
                        class="match-score-or-time-container match-score-or-time__pad-for-red-card"
                      >
                        <div class="match-score-or-time__strikethrough">
                          {{ level2.matchTime }}
                        </div>
                      </div>
                      <div
                        v-else-if="level2.matchState !== 0"
                        class="match-score-or-time-container"
                      >
                        <div class="match-detail__score home-match__icon-team">
                          {{ level2.opponents[0].score }}
                        </div>
                        <div class="match-middle__seperator">-</div>
                        <div class="home-match__icon-team match-detail__score">
                          {{ level2.opponents[1].score }}
                        </div>
                      </div>
                      <div
                        class="match-score-or-time-container match-score-or-time__pad-for-red-card"
                        v-else
                      >
                        {{ level2.matchStatus }}
                      </div>

                      <template
                        v-if="
                          level2.opponents[0].penaltyScore !== null &&
                          level2.opponents[1].penaltyScore !== null
                        "
                      >
                        <div class="match-penalty-score-wrapper">
                          PEN:
                          {{ level2.opponents[0].penaltyScore
                          }}<span class="match-penalty-score-separator">-</span
                          >{{ level2.opponents[1].penaltyScore }}
                        </div>
                      </template>
                    </div>

                    <!-- <div class="display-flex-sb flex-1 h-100"> -->
                    <div class="match-detail">
                      <div class="match-detail__team-container">
                        <div class="icon-league">
                          <span
                            class="penalty-compact-label left"
                            v-if="level2.opponents[1].penaltyWin"
                            >P</span
                          >
                          <span class="team-fav-icon-left">
                            <FavStarIcon
                              v-if="level2.opponents[1].isFavTeam"
                              starType="small"
                            />
                          </span>
                          <img
                            :src="`${s3ImgUrl}/${level2.opponents[1].logo}`"
                          />
                        </div>
                        <div class="match-detail__name">
                          {{ level2.opponents[1].name }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="isLogin"
                      class="btn-fav-wrapper"
                      @click="handleFavMatchClick(o, level2, $event)"
                    >
                      <div
                        class="btn-fav-aspn"
                        :class="[
                          favMatchClassObj(level2),
                          {
                            'fav-page': type === 'fav',
                          },
                        ]"
                      ></div>
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
                <!-- <div
                v-if="type === 'team' && params.selectedCurrentChildMenuIndex === 2"
                :class="`match-table__standings__form-ball ball-${'2'}`" >
                {{ level2.winlose === '0' ? 'W' : 
                      level2.winlose === '1' ? 'D' : 
                      level2.winlose === '2' ? 'L' : '' 
                    }}
                    L
              </div> -->
              </div>

              <div class="home-match__actions-card__wrapper">
                <!-- <div class="home-match__icon-match"></div> -->
                <!-- @click.prevent="toggleStatsPopover(level2)" -->
                <!-- Hide Odds: v-show="isLogin" -->
                <div
                  class="home-match__icon-wrapper"
                  @mouseenter="showStatsPopover(level2)"
                  @mouseleave="hideStatsPopover(level2)"
                  @click.prevent
                  v-show="!noOdd"
                >
                  <div
                    class="home-match__icon-stats"
                    :class="{
                      selected: level2.isShowStatsPopover,
                    }"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="14px"
                      height="14px"
                      viewBox="0 0 14 14"
                      version="1.1"
                    >
                      <path
                        style="
                          stroke: none;
                          fill-rule: nonzero;
                          fill-opacity: 1;
                        "
                        d="M 0.46875 4.386719 L 3.269531 4.386719 L 3.269531 13.535156 L 0.46875 13.535156 Z M 5.695312 0.46875 L 8.308594 0.46875 L 8.308594 13.535156 L 5.695312 13.535156 Z M 10.921875 7.933594 L 13.535156 7.933594 L 13.535156 13.535156 L 10.921875 13.535156 Z M 10.921875 7.933594 "
                      />
                    </svg>
                  </div>
                  <StatsContainerPopover
                    :matchId="level2.matchId"
                    v-if="level2.isShowStatsPopover"
                  ></StatsContainerPopover>
                </div>
                <!-- Hide Odds: :class="{'rounded-right': !isLogin}" -->
                <!-- <div
                v-if="level2.containLiveStream"
                class="home-match__icon-wrapper"
                :class="{ 'rounded-right': noOdd }"
              >
                <div
                  class="home-match__icon-livevideo"
                  @click="handleHighlight(o, level2, $event)"
                ></div>
              </div> -->
                <!-- Hide Odds: :class="{'rounded-right': !isLogin}" -->
                <!-- <div
                v-else
                class="home-match__icon-wrapper"
                :class="{ 'rounded-right': noOdd }"
              >
                <div
                  class="home-match__icon-highlight"
                  :class="{ selected: level2.containHighlight }"
                  @click="handleHighlight(o, level2, $event)"
                ></div>
              </div> -->
              </div>
              <!-- Hide Odds: v-show="isLogin" -->
              <div
                class="home-match__static-card__wrapper"
                @click="handleRedirect(o, level2, $event)"
                @mouseenter="handleShowOddsDetailHover(o, level2, $event)"
                @mouseleave="handleShowOddsDetailLeave(o, level2, $event)"
                v-show="!noOdd"
              >
                <template
                  v-if="
                    (type === 'team' || type === 'league') &&
                    level2.oddsMatchShowBriefData
                  "
                >
                  <OddsMatchContentOverview
                    :oddsMatchData="level2.oddsMatchOverview"
                    :isShowBriefData="level2.oddsMatchShowBriefData"
                  ></OddsMatchContentOverview>
                </template>

                <template
                  v-else-if="
                    (type === 'team' || type === 'league') &&
                    !level2.oddsMatchShowBriefData
                  "
                >
                  <OddsMatchContentOverview
                    :oddsMatchData="level2.oddsMatchOverview"
                    :isShowBriefData="level2.oddsMatchShowBriefData"
                  ></OddsMatchContentOverview>
                  <OddsMatchContentDetail
                    v-if="level2.isShowOddsDetail"
                    :oddsMatchData="oddsMatch"
                  ></OddsMatchContentDetail>
                </template>

                <template v-else>
                  <OddsMatchContentOverview
                    :oddsMatchData="level2.oddsMatchOverview"
                    :isShowBriefData="oddsMatch.isShowBriefData"
                  ></OddsMatchContentOverview>
                  <OddsMatchContentDetail
                    v-if="level2.isShowOddsDetail"
                    :oddsMatchData="oddsMatch"
                  ></OddsMatchContentDetail>
                </template>
              </div>
            </router-link>
          </template>
        </template>
        <template v-else>
          <div v-if="type === 'league'" class="home-match__date">
            {{ o.formattedMatchDate }}
          </div>
          <router-link
            v-else-if="!['league', 'homeFavList'].includes(type)"
            :to="{
              path: `/${currentLocale}/${currentSportType}/${o.countryKey}/${o.leagueKey}`,
              query: {
                leagueId: o.leagueId,
                subLeagueId: o.subLeagueId,
              },
            }"
            class="display-flex-align-center home-match__title-wrapper"
          >
            <leagueIcon
              :icon="o.leagueKey"
              className="mr-05rem icon-league home-match__title-flag"
            >
              <Icon
                :logoUrl="o.logo"
                class="mr-05rem home-match__title-flag"
              ></Icon>
            </leagueIcon>
            <div class="home-match__title">
              <div class="home-match-country">
                {{ o.country }}
              </div>
              <span v-if="o.leagueName !== null">{{ o.leagueName }}</span>
              <span v-if="!!o.subLeagueName">: {{ o.subLeagueName }}</span>
              <span class="league-fav-icon">
                <FavStarIcon v-if="o.isFavLeague" />
              </span>
            </div>
          </router-link>
          <div
            v-show="type === 'homeFavList' && index === 0"
            class="display-flex home-match__title-wrapper home-match-title-fav"
          >
            <div class="btn-fav selected mr-05rem"></div>
            <span class="home-match__title">{{ $t("FAVOURITE") }}</span>
          </div>
          <router-link
            :to="{
              path: `/${currentLocale}/${currentSportType}/${
                o.countryKey ?? countryKey
              }/${o.leagueKey ?? leagueKey}/${
                level2.opponents[0].name.replace(/(\s|\/)/g, '-') +
                '-vs-' +
                level2.opponents[1].name.replace(/\s|\//g, '-')
              }/${level2.matchId}`,
            }"
            class="match-container"
            :class="{
              'fav-match-container': type === 'homeFavList',
              'league-match-container': type === 'league',
            }"
            v-for="(level2, index) in type === 'homeFavList'
              ? favMatchList(o.matchList)
              : o.matchList"
            :key="index"
          >
            <div
              class="home-match__score-card__wrapper"
              :class="{
                'live-selected': level2.isLive,
                'rounded-right': noOdd,
                'match-end': level2.matchState !== 0,
              }"
            >
              <div class="home-match__1-wrapper 12">
                <div
                  class="display-flex-sb home-match__1-container"
                  :key="index"
                >
                  <!-- <div class="display-flex-sb flex-1 h-100"> -->
                  <div class="home-match__status">
                    <span
                      v-show="type === 'team' && level2.matchState !== 0"
                      v-html="statusWithoutComma(level2.matchStatus)"
                    ></span>
                    <span v-show="type !== 'team' && level2.matchState !== 0">{{
                      statusWithoutComma(level2.matchStatus)
                    }}</span>
                  </div>
                  <div class="match-detail">
                    <div class="match-detail__team-container">
                      <div class="icon-league">
                        <span
                          class="penalty-compact-label right"
                          v-if="level2.opponents[0].penaltyWin"
                          >P</span
                        >
                        <img :src="`${s3ImgUrl}/${level2.opponents[0].logo}`" />
                        <span class="team-fav-icon-right">
                          <FavStarIcon
                            v-if="level2.opponents[0].isFavTeam"
                            starType="small"
                          />
                        </span>
                      </div>
                      <div class="match-detail__name">
                        {{ level2.opponents[0].name }}
                      </div>
                    </div>
                  </div>
                  <!-- </div> -->

                  <div class="match-score-or-time-section">
                    <div
                      v-if="
                        level2.matchState !== 0 &&
                        !['Postp.', 'TBA'].includes(level2.matchStatus)
                      "
                      :class="[
                        level2.opponents[0].redCard < 1 &&
                        level2.opponents[1].redCard < 1
                          ? 'match-score-or-time__pad-for-red-card'
                          : 'team-red-card-section',
                      ]"
                    >
                      <div class="team-red-card-container">
                        <template v-if="level2.opponents[0].redCard >= 3">
                          <div class="team-red-card-container">
                            <div
                              class="team-red-card"
                              v-for="card in 3"
                              :key="card"
                            ></div>
                          </div>
                        </template>
                        <template v-else-if="level2.opponents[0].redCard < 3">
                          <div class="team-red-card-container">
                            <div
                              class="team-red-card"
                              v-for="card in level2.opponents[0].redCard"
                              :key="card"
                            ></div>
                          </div>
                        </template>
                      </div>
                      <div class="team-red-card-container">
                        <template v-if="level2.opponents[1].redCard >= 3">
                          <div class="team-red-card-container">
                            <div
                              class="team-red-card"
                              v-for="card in 3"
                              :key="card"
                            ></div>
                          </div>
                        </template>
                        <template v-else-if="level2.opponents[1].redCard < 3">
                          <div class="team-red-card-container">
                            <div
                              class="team-red-card"
                              v-for="card in level2.opponents[1].redCard"
                              :key="card"
                            ></div>
                          </div>
                        </template>
                      </div>
                    </div>

                    <div
                      v-if="['Postp.', 'TBA'].includes(level2.matchStatus)"
                      class="match-score-or-time-container match-score-or-time__pad-for-red-card"
                    >
                      <div class="match-score-or-time__strikethrough">
                        {{ level2.matchTime }}
                      </div>
                    </div>
                    <div
                      v-else-if="level2.matchState !== 0"
                      class="match-score-or-time-container"
                    >
                      <div class="match-detail__score home-match__icon-team">
                        {{ level2.opponents[0].score }}
                      </div>
                      <div class="match-middle__seperator">-</div>
                      <div class="home-match__icon-team match-detail__score">
                        {{ level2.opponents[1].score }}
                      </div>
                    </div>
                    <div
                      class="match-score-or-time-container match-score-or-time__pad-for-red-card"
                      v-else
                    >
                      {{ level2.matchStatus }}
                    </div>

                    <template
                      v-if="
                        level2.opponents[0].penaltyScore !== null &&
                        level2.opponents[1].penaltyScore !== null
                      "
                    >
                      <div class="match-penalty-score-wrapper">
                        PEN:
                        {{ level2.opponents[0].penaltyScore
                        }}<span class="match-penalty-score-separator">-</span
                        >{{ level2.opponents[1].penaltyScore }}
                      </div>
                    </template>
                  </div>

                  <!-- <div class="display-flex-sb flex-1 h-100"> -->
                  <div class="match-detail">
                    <div class="match-detail__team-container">
                      <div class="icon-league">
                        <span
                          class="penalty-compact-label left"
                          v-if="level2.opponents[1].penaltyWin"
                          >P</span
                        >
                        <span class="team-fav-icon-left">
                          <FavStarIcon
                            v-if="level2.opponents[1].isFavTeam"
                            starType="small"
                          />
                        </span>
                        <img :src="`${s3ImgUrl}/${level2.opponents[1].logo}`" />
                      </div>
                      <div class="match-detail__name">
                        {{ level2.opponents[1].name }}
                      </div>
                    </div>
                  </div>
                  <div class="btn-fav-wrapper">
                    <div
                      v-if="isLogin"
                      @click="handleFavMatchClick(o, level2, $event)"
                      class="btn-fav-aspn match-list-fav"
                      :class="[favMatchClassObj(level2)]"
                    ></div>
                  </div>
                  <!-- </div> -->
                </div>
              </div>
              <!-- <div
                v-if="type === 'team' && params.selectedCurrentChildMenuIndex === 2"
                :class="`match-table__standings__form-ball ball-${'2'}`" >
                {{ level2.winlose === '0' ? 'W' : 
                      level2.winlose === '1' ? 'D' : 
                      level2.winlose === '2' ? 'L' : '' 
                    }}
                    L
              </div> -->
            </div>

            <div class="home-match__actions-card__wrapper">
              <!-- <div class="home-match__icon-match"></div> -->
              <!-- @click.prevent="toggleStatsPopover(level2)" -->
              <!-- Hide Odds: v-show="isLogin" -->
              <div
                class="home-match__icon-wrapper"
                @mouseenter="showStatsPopover(level2)"
                @mouseleave="hideStatsPopover(level2)"
                @click.prevent
                v-show="!noOdd"
              >
                <div
                  class="home-match__icon-stats"
                  :class="{
                    selected: level2.isShowStatsPopover,
                  }"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="14px"
                    height="14px"
                    viewBox="0 0 14 14"
                    version="1.1"
                  >
                    <path
                      style="stroke: none; fill-rule: nonzero; fill-opacity: 1"
                      d="M 0.46875 4.386719 L 3.269531 4.386719 L 3.269531 13.535156 L 0.46875 13.535156 Z M 5.695312 0.46875 L 8.308594 0.46875 L 8.308594 13.535156 L 5.695312 13.535156 Z M 10.921875 7.933594 L 13.535156 7.933594 L 13.535156 13.535156 L 10.921875 13.535156 Z M 10.921875 7.933594 "
                    />
                  </svg>
                </div>
                <StatsContainerPopover
                  :matchId="level2.matchId"
                  v-if="level2.isShowStatsPopover"
                ></StatsContainerPopover>
              </div>
              <!-- Hide Odds: :class="{'rounded-right': !isLogin}" -->
              <!-- <div
                v-if="level2.containLiveStream"
                class="home-match__icon-wrapper"
                :class="{ 'rounded-right': noOdd }"
              >
                <div
                  class="home-match__icon-livevideo"
                  @click="handleHighlight(o, level2, $event)"
                ></div>
              </div> -->
              <!-- Hide Odds: :class="{'rounded-right': !isLogin}" -->
              <!-- <div
                v-else
                class="home-match__icon-wrapper"
                :class="{ 'rounded-right': noOdd }"
              >
                <div
                  class="home-match__icon-highlight"
                  :class="{ selected: level2.containHighlight }"
                  @click="handleHighlight(o, level2, $event)"
                ></div>
              </div> -->
            </div>
            <!-- Hide Odds: v-show="isLogin" -->
            <div
              class="home-match__static-card__wrapper"
              @click="handleRedirect(o, level2, $event)"
              @mouseenter="handleShowOddsDetailHover(o, level2, $event)"
              @mouseleave="handleShowOddsDetailLeave(o, level2, $event)"
              v-show="!noOdd"
            >
              <template
                v-if="
                  (type === 'team' || type === 'league') &&
                  level2.oddsMatchShowBriefData
                "
              >
                <OddsMatchContentOverview
                  :oddsMatchData="level2.oddsMatchOverview"
                  :isShowBriefData="level2.oddsMatchShowBriefData"
                ></OddsMatchContentOverview>
              </template>

              <template
                v-else-if="
                  (type === 'team' || type === 'league') &&
                  !level2.oddsMatchShowBriefData
                "
              >
                <OddsMatchContentOverview
                  :oddsMatchData="level2.oddsMatchOverview"
                  :isShowBriefData="level2.oddsMatchShowBriefData"
                ></OddsMatchContentOverview>
                <OddsMatchContentDetail
                  v-if="level2.isShowOddsDetail"
                  :oddsMatchData="oddsMatch"
                ></OddsMatchContentDetail>
              </template>

              <template v-else>
                <OddsMatchContentOverview
                  :oddsMatchData="level2.oddsMatchOverview"
                  :isShowBriefData="oddsMatch.isShowBriefData"
                ></OddsMatchContentOverview>
                <OddsMatchContentDetail
                  v-if="level2.isShowOddsDetail"
                  :oddsMatchData="oddsMatch"
                ></OddsMatchContentDetail>
              </template>
            </div>
          </router-link>
        </template>
      </div>
    </template>

    <template v-if="isMobile">
      <div
        class="home-match__wrapper"
        :class="{
          'fav-wrapper': type === 'fav',
          fav: type === 'homeFavList',
          last: type === 'homeFavList' && index === matchList.length - 1,
          league: type === 'league',
        }"
        v-for="(o, index) in matchList"
        :key="index"
        v-show="!isLoading && !isShowNoData"
      >
        <template v-if="type === 'fav'">
          <div
            class="display-flex-align-center home-match__title-wrapper capitalize home-match-fav-title"
          >
            {{ o.matchDate }}
          </div>

          <template v-for="(l, index) in o.leagueMatchList" :key="index">
            <router-link
              :to="{
                path: `/${currentLocale}/${currentSportType}/${l.countryKey}/${l.leagueKey}`,
                query: {
                  leagueId: l.leagueId,
                  subLeagueId: l.subLeagueId,
                },
              }"
              class="display-flex-align-center home-match__title-wrapper league-title"
              :class="{
                first: index === 0,
              }"
            >
              <leagueIcon
                :icon="l.leagueKey"
                className="icon-league-fav mr-05rem"
              >
                <Icon
                  :logoUrl="l.logo"
                  class="mr-05rem home-match__title-flag"
                ></Icon>
              </leagueIcon>
              <div>
                <div class="home-match__title small">
                  {{ l.country }}
                </div>
                <div class="home-match__title" v-if="l.leagueName !== null">
                  {{ l.leagueName }}
                </div>
              </div>
            </router-link>
            <!-- v-for="(level2, index) in type === 'homeFavList' ? favMatchList(o.matchList) : o.matchList" -->
            <router-link
              :to="{
                path: `/${currentLocale}/${currentSportType}/${
                  l.countryKey ?? countryKey
                }/${l.leagueKey ?? leagueKey}/${
                  level2.opponents[0].name.replace(/(\s|\/)/g, '-') +
                  '-vs-' +
                  level2.opponents[1].name.replace(/\s|\//g, '-')
                }/${level2.matchId}`,
              }"
              class="match-container"
              :class="{
                'fav-match-container': type === 'homeFavList',
                'fav-page-match-container mb':
                  type === 'fav' && l.matchList.length > 1,
                'fav-page-match-container':
                  type === 'fav' && l.matchList.length <= 1,
              }"
              v-for="(level2, index) in l.matchList"
              :key="index"
            >
              <div
                class="home-match__card home-match__card-odds w-100"
                :class="{
                  'live-selected': level2.isLive,
                  'rounded-right': noOdd,
                  'home-match__card__status-top': isShowStatusAtTop,
                }"
              >
                <div class="display-flex-sb">
                  <div class="home-match__status">
                    <span
                      v-show="type === 'team' && level2.matchState !== 0"
                      v-html="level2.matchStatus"
                    ></span>
                    <span v-show="type !== 'team' && level2.matchState !== 0">{{
                      level2.matchStatus
                    }}</span>
                  </div>
                  <div class="home-match__1-wrapper">
                    <div
                      class="display-flex home-match__1-container"
                      :key="index"
                    >
                      <div class="display-flex-sb flex-1 h-100">
                        <div class="match-detail">
                          <div
                            class="match-detail__team-container"
                            :class="{
                              'penalty-team-container':
                                level2.opponents[0].penaltyScore !== null &&
                                level2.opponents[1].penaltyScore !== null,
                            }"
                          >
                            <div class="icon-league">
                              <span
                                class="penalty-compact-label right"
                                v-if="level2.opponents[0].penaltyWin"
                                >P</span
                              >
                              <img
                                :src="`${s3ImgUrl}/${level2.opponents[0].logo}`"
                              />
                              <span class="team-fav-icon-right">
                                <FavStarIcon
                                  v-if="level2.opponents[0].isFavTeam"
                                  starType="small"
                                />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        class="match-score-or-time-section"
                        :class="{
                          'has-pen':
                            level2.opponents[0].penaltyScore !== null &&
                            level2.opponents[1].penaltyScore !== null,
                        }"
                      >
                        <div
                          v-if="
                            level2.matchState !== 0 &&
                            !['Postp.', 'TBA'].includes(level2.matchStatus)
                          "
                          :class="[
                            level2.opponents[0].redCard < 1 &&
                            level2.opponents[1].redCard < 1
                              ? 'match-score-or-time__pad-for-red-card'
                              : 'team-red-card-section',
                          ]"
                        >
                          <div class="team-red-card-container">
                            <template v-if="level2.opponents[0].redCard >= 3">
                              <div class="team-red-card-container">
                                <div
                                  class="team-red-card"
                                  v-for="card in 3"
                                  :key="card"
                                ></div>
                              </div>
                            </template>
                            <template
                              v-else-if="level2.opponents[0].redCard < 3"
                            >
                              <div class="team-red-card-container">
                                <div
                                  class="team-red-card"
                                  v-for="card in level2.opponents[0].redCard"
                                  :key="card"
                                ></div>
                              </div>
                            </template>
                          </div>
                          <div class="team-red-card-container">
                            <template v-if="level2.opponents[1].redCard >= 3">
                              <div class="team-red-card-container">
                                <div
                                  class="team-red-card"
                                  v-for="card in 3"
                                  :key="card"
                                ></div>
                              </div>
                            </template>
                            <template
                              v-else-if="level2.opponents[1].redCard < 3"
                            >
                              <div class="team-red-card-container">
                                <div
                                  class="team-red-card"
                                  v-for="card in level2.opponents[1].redCard"
                                  :key="card"
                                ></div>
                              </div>
                            </template>
                          </div>
                        </div>

                        <div
                          v-if="['Postp.', 'TBA'].includes(level2.matchStatus)"
                          class="match-score-or-time-container match-score-or-time__pad-for-red-card match-score-or-time-container-fav"
                        >
                          <div class="match-score-or-time__strikethrough">
                            {{ level2.matchTime }}
                          </div>
                        </div>
                        <div
                          v-else-if="level2.matchState !== 0"
                          class="match-score-or-time-container"
                        >
                          <div
                            class="match-detail__score home-match__icon-team"
                          >
                            {{ level2.opponents[0].score }}
                          </div>
                          <div class="match-middle__seperator">-</div>
                          <div
                            class="home-match__icon-team match-detail__score"
                          >
                            {{ level2.opponents[1].score }}
                          </div>
                        </div>
                        <div
                          class="match-score-or-time-container match-score-or-time__pad-for-red-card match-score-or-time-container-fav"
                          v-else
                        >
                          {{ level2.matchStatus }}
                        </div>

                        <template
                          v-if="
                            level2.opponents[0].penaltyScore !== null &&
                            level2.opponents[1].penaltyScore !== null
                          "
                        >
                          <div class="match-penalty-score-wrapper">
                            PEN:
                            {{ level2.opponents[0].penaltyScore
                            }}<span class="match-penalty-score-separator"
                              >-</span
                            >{{ level2.opponents[1].penaltyScore }}
                          </div>
                        </template>
                      </div>

                      <div class="display-flex-sb flex-1 h-100">
                        <div class="match-detail">
                          <div
                            class="match-detail__team-container"
                            :class="{
                              'penalty-team-container':
                                level2.opponents[0].penaltyScore !== null &&
                                level2.opponents[1].penaltyScore !== null,
                            }"
                          >
                            <div class="icon-league">
                              <span
                                class="penalty-compact-label left"
                                v-if="level2.opponents[1].penaltyWin"
                                >P</span
                              >
                              <span class="team-fav-icon-left">
                                <FavStarIcon
                                  v-if="level2.opponents[1].isFavTeam"
                                  starType="small"
                                />
                              </span>
                              <img
                                :src="`${s3ImgUrl}/${level2.opponents[1].logo}`"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="isLogin"
                    class="btn-fav-wrapper"
                    @click="handleFavMatchClick(o, level2, $event)"
                  >
                    <div
                      class="btn-fav-aspn-mobile fav-page"
                      :class="[favMatchClassObj(level2)]"
                    ></div>
                  </div>
                  <div v-else></div>
                </div>

                <div class="display-flex-se mobile-match-card-name">
                  <div class="match-detail__name">
                    {{ level2.opponents[0].name }}
                  </div>
                  <div class="match-detail__name">
                    {{ level2.opponents[1].name }}
                  </div>
                </div>
                <!-- <div
                v-if="type === 'team' && params.selectedCurrentChildMenuIndex === 2"
                :class="`match-table__standings__form-ball ball-${'2'}`" >
                {{ level2.winlose === '0' ? 'W' : 
                      level2.winlose === '1' ? 'D' : 
                      level2.winlose === '2' ? 'L' : '' 
                    }}
                    L
              </div> -->
              </div>

              <div class="home-match__actions-card__wrapper">
                <!-- <div class="home-match__icon-match"></div> -->
                <!-- @click.prevent="toggleStatsPopover(level2)" -->
                <!-- Hide Odds: v-show="isLogin" -->
                <div
                  class="home-match__icon-wrapper"
                  @mouseenter="showStatsPopover(level2)"
                  @mouseleave="hideStatsPopover(level2)"
                  @click.prevent
                  v-show="!noOdd"
                >
                  <div
                    class="home-match__icon-stats"
                    :class="{
                      selected: level2.isShowStatsPopover,
                    }"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="14px"
                      height="14px"
                      viewBox="0 0 14 14"
                      version="1.1"
                    >
                      <path
                        style="
                          stroke: none;
                          fill-rule: nonzero;
                          fill-opacity: 1;
                        "
                        d="M 0.46875 4.386719 L 3.269531 4.386719 L 3.269531 13.535156 L 0.46875 13.535156 Z M 5.695312 0.46875 L 8.308594 0.46875 L 8.308594 13.535156 L 5.695312 13.535156 Z M 10.921875 7.933594 L 13.535156 7.933594 L 13.535156 13.535156 L 10.921875 13.535156 Z M 10.921875 7.933594 "
                      />
                    </svg>
                  </div>
                  <StatsContainerPopover
                    :matchId="level2.matchId"
                    v-if="level2.isShowStatsPopover"
                  ></StatsContainerPopover>
                </div>
                <!-- Hide Odds: :class="{'rounded-right': !isLogin}" -->
                <!-- <div
                v-if="level2.containLiveStream"
                class="home-match__icon-wrapper"
                :class="{ 'rounded-right': noOdd }"
              >
                <div
                  class="home-match__icon-livevideo"
                  @click="handleHighlight(o, level2, $event)"
                ></div>
              </div> -->
                <!-- Hide Odds: :class="{'rounded-right': !isLogin}" -->
                <!-- <div
                v-else
                class="home-match__icon-wrapper"
                :class="{ 'rounded-right': noOdd }"
              >
                <div
                  class="home-match__icon-highlight"
                  :class="{ selected: level2.containHighlight }"
                  @click="handleHighlight(o, level2, $event)"
                ></div>
              </div> -->
              </div>
              <!-- Hide Odds: v-show="isLogin" -->
              <div
                class="home-match__static-card__wrapper"
                @click="handleRedirect(o, level2, $event)"
                @mouseenter="handleShowOddsDetailHover(o, level2, $event)"
                @mouseleave="handleShowOddsDetailLeave(o, level2, $event)"
                v-show="!noOdd"
              >
                <template
                  v-if="
                    (type === 'team' || type === 'league') &&
                    level2.oddsMatchShowBriefData
                  "
                >
                  <OddsMatchContentOverview
                    :oddsMatchData="level2.oddsMatchOverview"
                    :isShowBriefData="level2.oddsMatchShowBriefData"
                  ></OddsMatchContentOverview>
                </template>

                <template
                  v-else-if="
                    (type === 'team' || type === 'league') &&
                    !level2.oddsMatchShowBriefData
                  "
                >
                  <OddsMatchContentOverview
                    :oddsMatchData="level2.oddsMatchOverview"
                    :isShowBriefData="level2.oddsMatchShowBriefData"
                  ></OddsMatchContentOverview>
                  <OddsMatchContentDetail
                    v-if="level2.isShowOddsDetail"
                    :oddsMatchData="oddsMatch"
                  ></OddsMatchContentDetail>
                </template>

                <template v-else>
                  <OddsMatchContentOverview
                    :oddsMatchData="level2.oddsMatchOverview"
                    :isShowBriefData="oddsMatch.isShowBriefData"
                  ></OddsMatchContentOverview>
                  <OddsMatchContentDetail
                    v-if="level2.isShowOddsDetail"
                    :oddsMatchData="oddsMatch"
                  ></OddsMatchContentDetail>
                </template>
              </div>
            </router-link>
          </template>
        </template>
        <template v-else>
          <div v-if="type === 'league'" class="home-match__date">
            {{ o.formattedMatchDate }}
          </div>
          <div
            v-else-if="!['league', 'homeFavList'].includes(type)"
            class="display-flex-align-center home-match__title-wrapper mt-05rem"
          >
            <leagueIcon
              :icon="o.leagueKey"
              className="mr-05rem icon-league home-match__title-flag"
            >
              <Icon
                :logoUrl="o.logo"
                class="mr-05rem home-match__title-flag"
              ></Icon>
            </leagueIcon>
            <div class="home-match__title-container">
              <router-link
                v-if="!!o.leagueName"
                :to="{
                  path: `/${currentLocale}/${currentSportType}/${o.countryKey}/${o.leagueKey}`,
                  query: {
                    leagueId: o.leagueId,
                    subLeagueId: o.subLeagueId,
                  },
                }"
                class="home-match__title-country"
                >{{ o.country }}</router-link
              >
              <router-link
                v-else
                :to="{
                  path: `/${currentLocale}/${currentSportType}/${o.countryKey}/${o.leagueKey}`,
                  query: {
                    leagueId: o.leagueId,
                    subLeagueId: o.subLeagueId,
                  },
                }"
                class="home-match__title home-match__title-mobile"
                >{{ o.country }}</router-link
              >

              <router-link
                :to="{
                  path: `/${currentLocale}/${currentSportType}/${o.countryKey}/${o.leagueKey}`,
                  query: {
                    leagueId: o.leagueId,
                    subLeagueId: o.subLeagueId,
                  },
                }"
                class="home-match__title home-match__title-mobile"
              >
                <span v-if="!!o.leagueName">{{ o.leagueName }}</span>
                <!-- <span
                  class="icon-fav small has-subleague-fav"
                  v-if="o.isFavLeague"
                ></span> -->
                <span
                  class="has-subleague-fav"
                  v-if="o.leagueName && o.subLeagueName"
                >
                  :
                </span>
                <span v-if="!!o.subLeagueName">{{ o.subLeagueName }}</span>
                <span class="league-fav-icon">
                  <FavStarIcon v-if="o.isFavLeague" />
                </span>
              </router-link>
            </div>

            <!-- <div class="ml-s">
              <svg
                width="6"
                height="10"
                viewBox="0 0 6 10"
                class="home-match__title-icon"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.334961 8.46017L3.57913 5.20892L0.334961 1.95767L1.33371 0.958923L5.58371 5.20892L1.33371 9.45892L0.334961 8.46017Z"
                />
              </svg>
            </div> -->
          </div>
          <div
            v-show="type === 'homeFavList' && index === 0"
            class="display-flex-align-center home-match__title-wrapper fav-title"
          >
            <div class="btn-fav-aspn-mobile selected mr-05rem"></div>
            <span class="home-match__title">{{ $t("FAVOURITES") }}</span>
          </div>
          <div class="home-match__container">
            <router-link
              :to="{
                path: `/${currentLocale}/${currentSportType}/${
                  o.countryKey ?? countryKey
                }/${o.leagueKey ?? leagueKey}/${
                  level2.opponents[0].name.replace(/(\s|\/)/g, '-') +
                  '-vs-' +
                  level2.opponents[1].name.replace(/(\s|\/)/g, '-')
                }/${level2.matchId}`,
              }"
              class="home-match__card home-match__card-odds"
              :class="{
                'home-match__card__status-top': isShowStatusAtTop,
                'live-selected': level2.isLive,
              }"
              v-for="(level2, index) in o.matchList"
              :key="index"
            >
              <div class="display-flex-center w-100">
                <!-- Hide Odds: v-show="!isLogin" -->
                <div
                  class="home-match__card-odds-time-not-logged-in home-match__status"
                  :class="{ longer: type === 'team' }"
                >
                  <span
                    :class="{
                      'match-status__live': level2.matchStatus === 'Live',
                    }"
                    v-show="type === 'team' && level2.matchState !== 0"
                    v-html="statusWithoutComma(level2.matchStatus)"
                  ></span>
                  <span
                    :class="{
                      'match-status__live': level2.matchStatus === 'Live',
                    }"
                    v-show="type !== 'team' && level2.matchState !== 0"
                    >{{ statusWithoutComma(level2.matchStatus) }}</span
                  >
                </div>
                <div class="w-100">
                  <!-- Hide Odds: :class="[isLogin ? 'display-flex' : 'display-flex-align-center']" -->
                  <div class="w-100 display-flex">
                    <!-- Hide Odds: :class="[isLogin ? 'home-match__card-odds-content' : 'home-match__card-odds-content-not-logged-in']" -->
                    <!-- <div class="home-match__card-odds-content-not-logged-in">
                      <div
                        class="home-match__detail"
                        v-for="(level3, index) in level2.opponents"
                        :key="index"
                      >
                        <div class="home-match__detail-opponent">
                          <Icon
                            :logoUrl="level3.logo"
                            class="home-match__icon"
                          ></Icon>
                          <span
                            class="mr-03rem home-match__team-name"
                            :class="{
                              'with-fav-star': level3.isFavTeam,
                              'with-penalty-score': level3.penaltyScore != null,
                              'with-penalty-win': level3.penaltyWin,
                            }"
                            >{{ level3.name }}</span
                          >
                          <span
                            class="icon-fav tiny mr-03rem"
                            v-if="level3.isFavTeam"
                          ></span>
                          <span
                            class="penalty-compact-label"
                            v-if="level3.penaltyWin"
                            >P</span
                          >
                        </div>
                        <div class="match-detail__score-wrapper">
                          <span class="score"> {{ level3.score }}</span>
                          <span
                            class="penalty-score score"
                            v-if="level3.penaltyScore != null"
                            >{{ level3.penaltyScore }}</span
                          >
                        </div>
                      </div>
                    </div> -->

                    <div class="match-detail">
                      <div
                        class="match-detail__team-container"
                        :class="{
                          'penalty-team-container':
                            level2.opponents[0].penaltyScore !== null &&
                            level2.opponents[1].penaltyScore !== null,
                        }"
                      >
                        <div class="icon-league">
                          <span
                            class="penalty-compact-label right"
                            v-if="level2.opponents[0].penaltyWin"
                            >P</span
                          >
                          <img
                            :src="`${s3ImgUrl}/${level2.opponents[0].logo}`"
                          />
                          <span class="team-fav-icon-right">
                            <FavStarIcon
                              v-if="level2.opponents[0].isFavTeam"
                              starType="small"
                            />
                          </span>
                        </div>
                        <!-- <div class="match-detail__name">
                          {{ level2.opponents[0].name }}
                        </div> -->
                      </div>
                    </div>

                    <div
                      class="match-score-or-time-section"
                      :class="{
                        'has-pen':
                          level2.opponents[0].penaltyScore !== null &&
                          level2.opponents[1].penaltyScore !== null,
                      }"
                    >
                      <div
                        v-if="
                          level2.matchState !== 0 &&
                          !['Postp.', 'TBA'].includes(level2.matchStatus)
                        "
                        :class="[
                          level2.opponents[0].redCard < 1 &&
                          level2.opponents[1].redCard < 1
                            ? 'match-score-or-time__pad-for-red-card'
                            : 'team-red-card-section',
                        ]"
                      >
                        <div class="team-red-card-container">
                          <template v-if="level2.opponents[0].redCard >= 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in 3"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                          <template v-else-if="level2.opponents[0].redCard < 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in level2.opponents[0].redCard"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                        </div>
                        <div class="team-red-card-container">
                          <template v-if="level2.opponents[1].redCard >= 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in 3"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                          <template v-else-if="level2.opponents[1].redCard < 3">
                            <div class="team-red-card-container">
                              <div
                                class="team-red-card"
                                v-for="card in level2.opponents[1].redCard"
                                :key="card"
                              ></div>
                            </div>
                          </template>
                        </div>
                      </div>

                      <div
                        v-if="['Postp.', 'TBA'].includes(level2.matchStatus)"
                        class="match-score-or-time-container match-score-or-time__pad-for-red-card"
                      >
                        <div class="match-score-or-time__strikethrough">
                          {{ level2.matchTime }}
                        </div>
                      </div>
                      <div
                        v-else-if="level2.matchState !== 0"
                        class="match-score-or-time-container"
                      >
                        <div class="match-detail__score home-match__icon-team">
                          {{ level2.opponents[0].score }}
                        </div>
                        <div class="match-middle__seperator">-</div>
                        <div class="home-match__icon-team match-detail__score">
                          {{ level2.opponents[1].score }}
                        </div>
                      </div>
                      <div
                        class="match-score-or-time-container match-score-or-time__pad-for-red-card"
                        v-else
                      >
                        {{ level2.matchStatus }}
                      </div>

                      <template
                        v-if="
                          level2.opponents[0].penaltyScore !== null &&
                          level2.opponents[1].penaltyScore !== null
                        "
                      >
                        <div class="match-penalty-score-wrapper">
                          PEN:
                          {{ level2.opponents[0].penaltyScore
                          }}<span class="match-penalty-score-separator">-</span
                          >{{ level2.opponents[1].penaltyScore }}
                        </div>
                      </template>
                    </div>
                    <div class="match-detail">
                      <div
                        class="match-detail__team-container"
                        :class="{
                          'penalty-team-container':
                            level2.opponents[0].penaltyScore !== null &&
                            level2.opponents[1].penaltyScore !== null,
                        }"
                      >
                        <div class="icon-league">
                          <span
                            class="penalty-compact-label left"
                            v-if="level2.opponents[1].penaltyWin"
                            >P</span
                          >
                          <img
                            :src="`${s3ImgUrl}/${level2.opponents[1].logo}`"
                          />
                          <span class="team-fav-icon-left">
                            <FavStarIcon
                              v-if="level2.opponents[1].isFavTeam"
                              starType="small"
                            />
                          </span>
                        </div>
                        <!-- <div class="match-detail__name">
                          {{ level2.opponents[1].name }}
                        </div> -->
                      </div>
                    </div>

                    <div v-show="isShowWinLose">
                      <div class="home-match__win-lose" :class="level2.winLose">
                        {{ level2.winLose }}
                      </div>
                    </div>

                    <!-- Hide Odds:  && !isLogin -->
                    <!-- <div
                      v-if="level2.containLiveStream"
                      class="home-match__icon-wrapper"
                    >
                      <div
                        class="home-match__icon-livevideo__mobile"
                        @click="handleHighlight(o, level2, $event)"
                      ></div>
                    </div> -->
                    <!-- Hide Odds:  && !isLogin -->
                    <!-- <div
                      v-else-if="!level2.containLiveStream"
                      class="home-match__icon-wrapper"
                    >
                      <div
                        class="home-match__icon-highlight__mobile"
                        :class="{ selected: level2.containHighlight }"
                        @click="handleHighlight(o, level2, $event)"
                      ></div>
                    </div> -->

                    <!-- Hide Odds: v-show="isLogin" -->
                    <div
                      class="home-match__static-card__wrapper 2"
                      @click="handleShowOddsDetailMobile(o, level2, $event)"
                      v-show="!noOdd"
                    >
                      <template
                        v-if="
                          (type === 'team' || type === 'league') &&
                          level2.oddsMatchShowBriefData
                        "
                      >
                        <OddsMatchContentOverview
                          :team="level3"
                          :oddsMatchData="level2.oddsMatchOverview"
                          :isShowBriefData="level2.oddsMatchShowBriefData"
                        ></OddsMatchContentOverview>
                        <OddsMatchContentDetail
                          :team="level3"
                          v-if="level2.isShowOddsDetail"
                          :oddsMatchData="oddsMatch"
                        ></OddsMatchContentDetail>
                      </template>

                      <template v-else>
                        <OddsMatchContentOverview
                          :team="level2.oddsMatchOverview"
                          :oddsMatchData="level2.oddsMatchOverview"
                          :isShowBriefData="oddsMatch.isShowBriefData"
                        ></OddsMatchContentOverview>
                        <OddsMatchContentDetail
                          v-if="level2.isShowOddsDetail"
                          :team="level2.oddsMatchOverview"
                          :oddsMatchData="oddsMatch"
                        ></OddsMatchContentDetail>
                      </template>
                    </div>
                  </div>
                  <!-- Hide Odds: v-show="isLogin" -->
                  <div class="home-match__card-odds-bottom" v-show="!noOdd">
                    <div
                      class="home-match__card-odds-time"
                      :class="{
                        'match-detail__status-w-auto': isStatusWidthAuto,
                      }"
                    >
                      <span
                        :class="{
                          'match-status__live': level2.matchStatus === 'Live',
                        }"
                        v-show="type === 'team'"
                        v-html="level2.matchStatus"
                      ></span>
                      <span
                        :class="{
                          'match-status__live': level2.matchStatus === 'Live',
                        }"
                        v-show="type !== 'team'"
                        >{{ level2.matchStatus }}</span
                      >
                    </div>
                    <div class="display-flex-center">
                      <!-- <div class="home-match__icon-match__mobile"></div> -->
                      <div
                        class="home-match__icon-wrapper"
                        @click="showStatsPopoverMobile(level2, $event)"
                        v-show="isLogin"
                      >
                        <div class="home-match__icon-stats">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="14px"
                            height="14px"
                            viewBox="0 0 14 14"
                            version="1.1"
                          >
                            <path
                              style="
                                stroke: none;
                                fill-rule: nonzero;
                                fill-opacity: 1;
                              "
                              d="M 0.46875 4.386719 L 3.269531 4.386719 L 3.269531 13.535156 L 0.46875 13.535156 Z M 5.695312 0.46875 L 8.308594 0.46875 L 8.308594 13.535156 L 5.695312 13.535156 Z M 10.921875 7.933594 L 13.535156 7.933594 L 13.535156 13.535156 L 10.921875 13.535156 Z M 10.921875 7.933594 "
                            />
                          </svg>
                        </div>
                      </div>
                      <!-- <div
                        v-if="level2.containLiveStream"
                        class="home-match__icon-wrapper"
                      >
                        <div
                          class="home-match__icon-livevideo__mobile"
                          @click="handleHighlight(o, level2, $event)"
                        ></div>
                      </div>
                      <div v-else class="home-match__icon-wrapper">
                        <div
                          class="home-match__icon-highlight__mobile"
                          :class="{ selected: level2.containHighlight }"
                          @click="handleHighlight(o, level2, $event)"
                        ></div>
                      </div> -->
                    </div>
                  </div>
                </div>

                <!-- Hide Odds: :class="{'btn-fav-wrapper__mobile': isLogin}" -->
                <div
                  class="btn-fav-wrapper btn-fav-wrapper__mobile-phase-2-no-odds"
                >
                  <div
                    v-if="isLogin"
                    @click="handleFavMatchClick(o, level2, $event)"
                    class="btn-fav-aspn-mobile"
                    :class="favMatchClassObj(level2)"
                  ></div>
                  <div v-else class="btn-fav-aspn-blank"></div>
                </div>
              </div>

              <div class="display-flex-se mobile-match-card-name">
                <div class="match-detail__name">
                  {{ level2.opponents[0].name }}
                </div>
                <!-- <div>&nbsp;</div> -->
                <div class="match-detail__name">
                  {{ level2.opponents[1].name }}
                </div>
              </div>
            </router-link>
          </div>
        </template>
      </div>
    </template>

    <template v-if="isMobile">
      <LoadingAspn
        type="league-match-card"
        v-show="isLoading && !isShowNoData && type === 'league'"
      />
      <LoadingAspn
        type="home-match-card"
        v-show="isLoading && !isShowNoData && type !== 'league'"
      />
    </template>
    <template v-else>
      <div v-show="isLoading && !isShowNoData" class="skeleton-match__wrapper">
        <div class="mb-2rem">
          <div class="skeleton-child skeleton-match__title"></div>
          <div class="skeleton-child skeleton-match__content"></div>
          <div class="skeleton-child skeleton-match__content"></div>
        </div>

        <div class="mb-2rem">
          <div class="skeleton-child skeleton-match__title"></div>
          <div class="skeleton-child skeleton-match__content"></div>
        </div>

        <div class="mb-2rem">
          <div class="skeleton-child skeleton-match__title"></div>
          <div class="skeleton-child skeleton-match__content"></div>
          <div class="skeleton-child skeleton-match__content"></div>
        </div>

        <div class="mb-2rem">
          <div class="skeleton-child skeleton-match__title"></div>
          <div class="skeleton-child skeleton-match__content"></div>
        </div>

        <div class="mb-2rem">
          <div class="skeleton-child skeleton-match__title"></div>
          <div class="skeleton-child skeleton-match__content"></div>
          <div class="skeleton-child skeleton-match__content"></div>
        </div>

        <div class="mb-2rem">
          <div class="skeleton-child skeleton-match__title"></div>
          <div class="skeleton-child skeleton-match__content"></div>
          <div class="skeleton-child skeleton-match__content"></div>
        </div>
      </div>
    </template>

    <!-- <Loading v-show="isLoading && !isShowNoData"></Loading> -->
    <NoData
      text="NO_MATCHES"
      v-show="!isLoading && isShowNoData"
      class="mt-05rem"
    />
    <!-- <div class="no-data" v-show="!isLoading && isShowNoData">
      <template v-if="type === 'fav'"> -->
    <!-- <FavCardMatch /> -->
    <!-- </template>
      <template v-else>
        
        {{ $t("NO_MATCHES") }}
      </template>
    </div> -->
    <ModalTransparent ref="modalPopupRef">
      <OddsMatchContentDetail
        :oddsMatchData="oddsMatch"
        @click="handleRedirectMobile()"
      ></OddsMatchContentDetail>
    </ModalTransparent>
    <ModalTransparent ref="statsTableModalPopupRef">
      <StatsContainerPopover :matchId="selectedMatchId"></StatsContainerPopover>
    </ModalTransparent>

    <PopUpSignInIndexMobile
      ref="PopUpSignInIndexMobileRef"
      :message="$i18n.t('FAV_LOGIN_TIPS')"
    ></PopUpSignInIndexMobile>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import OddsMatchContentDetail from "@/components/match/OddsMatchContentDetail.vue";
import OddsMatchContentOverview from "@/components/match/OddsMatchContentOverview.vue";
import StatsContainerPopover from "@/components/match/StatsContainerPopover.vue";
import ModalTransparent from "@/components/modal/ModalTransparent.vue";
import FavCardMatch from "@/views/fav/components/FavCardMatch.vue";

import leagueIcon from "@/components/Icon/LeagueIcon.vue";

import PopUpSignInIndexMobile from "@/components/user/PopUpSignInIndexMobile.vue";

import moment from "moment";
import config from "@/js/config.js";

import FavLoginTips from "@/components/favourite/TipsLogin.vue";
import FavStarIcon from "@/components/indicator/FavStarIcon.vue";
export default {
  components: {
    OddsMatchContentDetail,
    OddsMatchContentOverview,
    StatsContainerPopover,
    ModalTransparent,
    FavCardMatch,

    PopUpSignInIndexMobile,
    FavStarIcon,
    leagueIcon,
  },

  props: {
    matchObj: {
      type: Array,
    },
    isShowFav: {
      type: Boolean,
    },
    isShowWinLose: {
      type: Boolean,
    },
    WinLoseResult: {
      type: String,
    },
    params: {
      type: Object,
    },
    isStatusWidthAuto: {
      type: Boolean,
      default: false,
    },
    isShowStatusAtTop: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: null,
    },
    noOdd: {
      type: Boolean,
      default: true,
    },
  },

  watch: {
    params: {
      deep: true,
      handler(newVal, oldVal) {
        if (typeof newVal.leagueKey !== "undefined") {
          this.getFixtureByLeagueData(newVal);
        } else {
          // debugger;
          // this.getMatchListData(newVal);
        }
      },
    },
    $route() {},
  },

  data() {
    return {
      s3ImgUrl: config.s3ImgUrl,
      cnLocaleList: config.cnLocaleList,
      isLoading: false,
      isShowNoData: false,
      path: [],

      matchList: [],
      tmpMatchList: [],

      //odds info
      oddsMatch: {
        isShow: false,
        list: [], // store initial odds list
        isShowDetail: false,
        detailStyle: {},
        detailList: {}, //store current hover display odds detail list
        isShowBriefData: false,
      },

      currentMobileSelectedMatch: null,
      isShowOddsDetailMobile: false,
      count: 2,
      selectedMatchId: "",

      displayDateFormat: config.displayDateFormat,
      countryKey: "",
      leagueKey: "",
    };
  },

  computed: {
    ...mapGetters([
      "isMobile",
      "currentLocale",
      "currentLanguageObj",
      "currentSportType",
      "isLogin",
      "currentPathName",
      "userInfo",
    ]),
    matchList() {
      //filter for matchList if score ==="", then show "?"
      let matchList = this.matchList;
      let homeFavMatchList = [];
      if (this.type === "fav") {
        if (this.cnLocaleList.includes(this.currentLocale)) {
          matchList.forEach((x) => {
            let dateArr = x.matchDate.split(" ");
            dateArr[0] = dateArr[0] + "日";
            dateArr[2] = dateArr[2] + "年";
            x.matchDate = dateArr.join(" ");
          });
        }
      } else {
        for (let level1 = 0; level1 < matchList.length; level1++) {
          if (this.type === "league") {
            let options = {
              weekday: "short",
              year: "numeric",
              month: "short",
              day: "numeric",
            };
            let theDate = new Date(matchList[level1].matchDate);
            matchList[level1].formattedMatchDate = this.$tools.getDateByLocale(
              this.currentLanguageObj.apiParam.replace("_", "-"),
              options,
              theDate
            );
          }
          for (
            let level2 = 0;
            level2 < matchList[level1].matchList.length;
            level2++
          ) {
            if (this.type === "team") {
              let matchListLevel2 = matchList[level1].matchList[level2];
              if (matchListLevel2.matchState === 0)
                matchListLevel2.matchStatus =
                  matchListLevel2.matchStatus.split(" ")[1];

              // let dateTimePattern = /\d{2}\-[a-zA-Z]{3}\-\d{4} \d{2}\:\d{2}/;
              // if (
              //   dateTimePattern.test(matchListLevel2.matchStatus) &&
              //   !this.isMobile
              // ) {
              //   let classNames = !this.isMobile
              //     ? "display-flex-center flex-col"
              //     : "display-flex-se";
              //   let matchDate = matchListLevel2.matchDate.split("-"); //matchListLevel2.matchStatus.split("-")
              //   let matchDateTime = `<div class='${classNames}'><div>${
              //     matchListLevel2.matchTime
              //   }</div><div>${matchDate[2]}.${
              //     matchDate[1]
              //   }.${matchDate[0].substring(2)}</div></div>`;
              //   // `<div class='${classNames}'><div>${matchListLevel2.matchTime}</div><div>${matchDate[0]} ${matchDate[1]}</div></div>`
              //   matchListLevel2.matchStatus = matchDateTime;
              // }
            }

            for (
              let level3 = 0;
              level3 < matchList[level1].matchList[level2].opponents.length;
              level3++
            ) {
              if (
                matchList[level1].matchList[level2].opponents[level3].score ===
                ""
              ) {
                matchList[level1].matchList[level2].opponents[level3].score =
                  "-";
              }
            }

            if (this.type === "homeFavList") {
              let matchListLevel1 = matchList[level1];
              let matchListLevel2 = matchList[level1].matchList[level2];
              if (matchListLevel2.isFavMatch) {
                homeFavMatchList.push({
                  countryKey: matchListLevel1.countryKey,
                  leagueKey: matchListLevel1.leagueKey,
                  matchList: [matchListLevel2],
                });
              }
            }
          }
        }
      }
      if (this.type === "homeFavList") {
        matchList = homeFavMatchList.length > 0 ? homeFavMatchList : [];
        this.$emit("favMatchContentEvent", matchList); //broacast event to those who subscribe it
      }

      return matchList;
    },
  },
  created() {
    this.path = this.$route.path;
  },

  beforeMount() {
    //window.addEventListener('scroll', this.handleScroll)
  },
  mounted() {
    // this.currentPathName = window.location.pathname;
  },

  methods: {
    ...mapActions([
      "getMatchListAsync4",
      "getFixtureByLeague",
      "getMatchListByTeam",
      "getFavMatchList",
      "addFavMatch",
      "unFavMatch",
      "toastrFavChangeEvent",
      "favLoginTipsChangeEvent",
      "getFavBasketballMatchList",
    ]),
    statusWithoutComma(text) {
      return text.replace(/\.\s*$/gm, "");
    },
    favMatchList(matchList) {
      const arr = [];
      for (var index in matchList) {
        let isFav = matchList[index].isFavMatch;
        if (isFav) {
          arr.push(matchList[index]);
        }
        return arr;
      }
      return matchList;
    },
    replaceByDefault(e) {
      e.target.src = `${this.s3ImgUrl}/team/default.png`;
    },

    getFavMatchListData(newVal) {
      this.isShowNoData = false;
      this.isLoading = true;
      if (!newVal.isCallInterval) {
        this.matchList = [];
      } else {
        this.isLoading = false;
      }

      const theDate = moment(newVal.date).startOf("day");
      const today = moment().startOf("day");
      const diffDay = theDate.diff(today, "days");
      let isPreviousDate = diffDay < 0 ? true : false;
      this.$nextTick(async () => {
        let result;
        if (this.currentSportType == "football")
          result = await this.getFavMatchList(newVal);
        else if (this.currentSportType == "basketball")
          result = await this.getFavBasketballMatchList(newVal);

        if (result.result === null) {
          this.isShowNoData = true;
          this.$emit("isDataReturn", false);
        } else {
          if (result.result.matchDateList.length === 0) {
            this.isShowNoData = true;
            this.$emit("isDataReturn", false);
          } else {
            this.isShowNoData = false;
            this.$emit("isDataReturn", true);

            this.matchList = result.result.matchDateList;
            //sort by date
            this.matchList.sort((x, y) => {
              return moment(x.matchDate) - moment(y.matchDate);
            });

            this.matchList.forEach((element) => {
              element.matchDate = moment(element.matchDate).format(
                this.displayDateFormat
              );
            });

            this.oddsMatch.list = result.result.oddsListMatchMap;

            //only live, today and and future day show 6 data at match odds overview
            if (newVal.isLiveOnly) {
              this.oddsMatch.isShowBriefData = false;
            } else if (isPreviousDate) {
              this.oddsMatch.isShowBriefData = true;
            } else {
              this.oddsMatch.isShowBriefData = false;
            }

            //mapping odds value to match list
            for (let i = 0; i < this.matchList.length; i++) {
              let level1 = this.matchList[i].leagueMatchList;
              for (let y = 0; y < level1.length; y++) {
                let level2 = level1[y].matchList;
                if (!newVal.isCallInterval) {
                  level2.isShowOddsDetail = false;
                }

                for (let x = 0; x < level2.length; x++) {
                  level2[x].oddsMatchOverview =
                    this.oddsMatch.list[level2[x].matchId];
                }
              }
            }
            // setTimeout(() => {
            //     this.$emit("changeMatchContentEvent", this.matchList); //broacast event to those who subscribe it
            // }, 100);
          }
        }

        this.isLoading = false;
      });
    },

    getFavMatchListData2(matchSelected) {
      let params = {
        token: this.userInfo.token,
        timeZone: this.$tools.getCurrentTimeZone(),
        date: moment(new Date()).format("YYYY-MM-DD"),
        isCallInterval: false,
        isLiveOnly: false,
      };
      this.$nextTick(() => {
        if (this.currentSportType === "football") {
          if (matchSelected === 1) {
            // fixture
            params["type"] = 1;
            this.getFavMatchListData(params);
          } else {
            // results
            params["type"] = 2;
            this.getFavMatchListData(params);
          }
        } else if (this.currentSportType === "basketball") {
          this.getFavMatchListData(params);
        }
      });
    },

    async getMatchListData(newVal) {
      this.haha = "s";
      let params;
      if (this.type === "league") {
        params = newVal;
      } else {
        params = {
          leagueIdList: newVal.leagueIdList
            ? newVal.leagueIdList.toString()
            : "",
          matchDate: newVal.date,
          liveOnly: newVal.isLiveOnly,
          lang: this.currentLanguageObj.apiParam,
          timeZone: this.$tools.getCurrentTimeZone(),
        };
      }
      this.isShowNoData = false;

      if (newVal.isCallInterval) {
        this.isLoading = false;
      } else {
        this.isLoading = true;
        this.matchList = [];
      }

      const theDate = moment(params.matchDate).startOf("day");
      const today = moment().startOf("day");
      const diffDay = theDate.diff(today, "days");

      let isPreviousDate = diffDay < 0 ? true : false;
      let result, apiList;

      if (this.type === "league") {
        result = await this.getFixtureByLeague(params);
        this.countryKey = result.result.countryKey;
        this.leagueKey = result.result.leagueKey;
        apiList = "matchDateList";
        this.isLoading = false;
      } else if (this.type === "team") {
        this.getMatchListByTeamData({
          teamId: this.$route.params.teamKey,
        });
        return;
      } else {
        result = await this.getMatchListAsync4(params);
        apiList = "leagueMatchList";
        this.isLoading = false;
      }

      if (
        (this.type === "league" &&
          (result.result.length === 0 || result.result[apiList] === null)) ||
        (this.type !== "league" && result.result === null) // homepage
      ) {
        this.isShowNoData = true;

        if (this.type === "league") {
          this.$emit("changeMatchContentEvent", result.result); //broacast event to those who subscribe it
        }
      } else {
        this.isShowNoData = false;
        setTimeout(() => {}, 300);

        this.matchList = result.result[apiList];

        //match list sort by fav
        this.matchList.sort((x, y) => {
          return y.isFavLeague - x.isFavLeague;
        });

        if (this.type === "league") {
          this.oddsMatch.list = result.result.oddListMatchMap;
        } else {
          this.oddsMatch.list = result.result.oddsListMatchMap;
        }

        //only live, today and and future day show 6 data at match odds overview
        if (newVal.isLiveOnly) {
          this.oddsMatch.isShowBriefData = false;
        } else if (isPreviousDate) {
          this.oddsMatch.isShowBriefData = true;
        } else {
          this.oddsMatch.isShowBriefData = false;
        }

        //mapping odds value to match list
        for (let i = 0; i < this.matchList.length; i++) {
          let level1 = this.matchList[i].matchList;

          if (!newVal.isCallInterval) {
            level1.isShowOddsDetail = false;
          }

          for (let x = 0; x < level1.length; x++) {
            if (this.type === "league") {
              const theDate = moment(level1[x].matchDate).startOf("day");
              const today = moment().startOf("day");
              const diffDay = theDate.diff(today, "days");
              const isPreviousDate = diffDay < 0 ? true : false;
              //only today and and future day show 6 data at match odds overview
              if (isPreviousDate) {
                level1[x].oddsMatchShowBriefData = true;
              } else {
                level1[x].oddsMatchShowBriefData = false;
              }
            }

            level1[x].oddsMatchOverview =
              this.oddsMatch.list[level1[x].matchId];
          }
        }
        let gg = this.matchList;

        setTimeout(() => {
          this.$emit("changeMatchContentEvent", result.result); //broacast event to those who subscribe it
        }, 100);
      }

      // this.isLoading = false;
    },

    async getMatchListByTeamData(newVal) {
      let params = {
        teamId: newVal.teamId,
        timeZone: this.$tools.getCurrentTimeZone(),
      };

      if (newVal.type) {
        params["type"] = newVal.type;
      }
      if (newVal.leagueId) {
        params["leagueId"] = newVal.leagueId;
      }

      if (!newVal.isCallInterval) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }

      const result = await this.getMatchListByTeam(params);
      this.isLoading = false;
      if (result.result === null) {
        this.isShowNoData = true;
        this.$emit("changeMatchContentEvent", []);
      } else {
        if (result.result.leagueMatchList.length === 0) {
          this.isShowNoData = true;
          this.$emit("changeMatchContentEvent", []);
        } else {
          this.isShowNoData = false;

          this.matchList = result.result.leagueMatchList;

          //match list sort by fav
          this.matchList.sort((x, y) => {
            return y.isFavLeague - x.isFavLeague;
          });

          this.oddsMatch.list = result.result.oddsListMatchMap;

          //mapping odds value to match list
          for (let i = 0; i < this.matchList.length; i++) {
            let level1 = this.matchList[i].matchList;

            if (!newVal.isCallInterval) {
              level1.isShowOddsDetail = false;
            }

            for (let x = 0; x < level1.length; x++) {
              const theDate = moment(level1[x].matchDate).startOf("day");
              const today = moment().startOf("day");
              const diffDay = theDate.diff(today, "days");
              const isPreviousDate = diffDay < 0 ? true : false;
              level1[x].oddsMatchOverview =
                this.oddsMatch.list[level1[x].matchId];
              //only today and and future day show 6 data at match odds overview
              if (isPreviousDate) {
                level1[x].oddsMatchShowBriefData = true;
              } else {
                level1[x].oddsMatchShowBriefData = false;
              }
            }
          }

          this.$emit("changeMatchContentEvent", this.matchList);
        }
      }
    },

    async getFixtureByLeagueData(newVal) {
      let params = {
        leagueKey: newVal.leagueKey,
        matchDate: newVal.matchDate,
        timeZone: this.$tools.getCurrentTimeZone(),
      };
      this.isLoading = true;
      const result = await this.getFixtureByLeague(params);
      this.isLoading = false;
      this.matchList = result.result.matchList;

      if (this.matchList.length == 0) {
        this.isShowNoData = true;
      } else {
        this.isShowNoData = false;
      }

      this.$emit("changeMatchContentFixtureByLeagueEvent", this.matchList);
    },
    handleMatchDetailRoutePath(o, level2, e) {
      // if (level2.containLiveStream) {
      //     e.preventDefault();
      //     e.stopPropagation();
      //     let link = `/${this.currentLocale}/${this.currentSportType}/${o.countryKey}/${o.leagueKey}/${level2.matchName}/${level2.matchId}`;
      //     window.open(link);
      //     return false
      // } else {
      //     this.$tools.openNewWindow(e)
      // }
    },
    //redirect to highlightpage if the match contain highlight video
    handleHighlight(o, level2, e) {
      if (level2.containLiveStream) {
        e.preventDefault();
        e.stopPropagation();

        let link = `/${this.currentLocale}/${this.currentSportType}/${
          o.countryKey
        }/${o.leagueKey}/${
          level2.opponents[0].name.split(" ").join("-") +
          "-vs-" +
          level2.opponents[1].name.split(" ").join("-")
        }/${level2.matchId}`;
        window.open(link);
        return false;
      } else if (level2.containHighlight) {
        e.preventDefault();
        e.stopPropagation();

        this.$router.push({
          path: `/${this.currentLocale}/${this.currentSportType}/highlights/${
            o.countryKey
          }/${o.leagueKey}/${
            level2.opponents[0].name.split(" ").join("-") +
            "-vs-" +
            level2.opponents[1].name.split(" ").join("-")
          }/${level2.matchId}`,
          query: {
            date: level2.matchDate,
          },
        });
        return false;
      } else {
        e.preventDefault();
        e.stopPropagation();

        let link = `/${this.currentLocale}/${this.currentSportType}/${
          o.countryKey
        }/${o.leagueKey}/${
          level2.opponents[0].name.split(" ").join("-") +
          "-vs-" +
          level2.opponents[1].name.split(" ").join("-")
        }/${level2.matchId}`;
        window.open(link);
        return false;
      }
    },
    handleRedirect(o, level2, e) {
      e.preventDefault();
      e.stopPropagation();
      let team1 = level2.opponents[0].name
        .split(" ")
        .join("-")
        .replace(/\//g, "-");
      let team2 = level2.opponents[1].name
        .split(" ")
        .join("-")
        .replace(/\//g, "-");
      let link = `/${this.currentLocale}/${this.currentSportType}/${
        o.countryKey
      }/${o.leagueKey}/${team1 + "-vs-" + team2}/${level2.matchId}/stats`;
      window.open(link);
      return false;
    },
    handleRedirectMobile() {
      let link = `/${this.currentLocale}/${this.currentSportType}/${this.currentMobileSelectedMatch.parent.countryKey}/${this.currentMobileSelectedMatch.parent.leagueKey}/${this.currentMobileSelectedMatch.child.matchName}/${this.currentMobileSelectedMatch.child.matchId}/stats`;
      window.open(link);
    },
    selectFavMatch(o) {
      o.fav = !o.fav;
    },

    handleScroll() {
      let element = this.$refs.scrollComponent;

      if (element.getBoundingClientRect().bottom < window.innerHeight) {
        this.loadMorePosts();
      }
    },

    loadMorePosts() {
      if (this.tmpMatchList.length > 0) {
        let gg = this.count + 2;

        for (let i = this.count; i < gg; i++) {
          this.matchList.push(this.tmpMatchList[i]);
        }
        this.count = this.count + 2;
        if (this.count < this.tmpMatchList.length + 2) {
        }
      }
    },

    handleShowOddsDetailHover(o, level2, event) {
      if (
        this.oddsMatch.list[level2.matchId] &&
        !this.oddsMatch.isShowBriefData
      ) {
        level2.isShowOddsDetail = true;
        this.oddsMatch.data = level2;
        this.oddsMatch.detailList = this.oddsMatch.list[level2.matchId];
      }
    },

    handleShowOddsDetailLeave(o, level2) {
      level2.isShowOddsDetail = false;
    },

    handleShowOddsDetailMobile(o, level2, e) {
      this.currentMobileSelectedMatch = {
        parent: o,
        child: level2,
      };
      e.preventDefault();
      e.stopPropagation();
      if (
        (this.oddsMatch.list[level2.matchId] &&
          !this.oddsMatch.isShowBriefData &&
          this.type !== "league" &&
          this.type !== "team") ||
        (this.oddsMatch.list[level2.matchId] &&
          !level2.oddsMatchShowBriefData &&
          (this.type === "league" || this.type === "team"))
      ) {
        this.oddsMatch.data = level2;
        this.oddsMatch.detailList = this.oddsMatch.list[level2.matchId];
        this.$refs.modalPopupRef.handleOpen();
      }
    },

    // toggleStatsPopover(level2) {
    //     this.matchList.forEach(leagueList=> {
    //         leagueList.matchList.forEach(match => {
    //             match.isShowStatsPopover = false;
    //         });
    //     });
    //     level2.isShowStatsPopover = !level2.isShowStatsPopover;
    // },
    showStatsPopover(level2) {
      level2.isShowStatsPopover = true;
    },
    hideStatsPopover(level2) {
      level2.isShowStatsPopover = false;
    },
    showStatsPopoverMobile(level2, e) {
      e.preventDefault();
      e.stopPropagation();
      this.selectedMatchId = level2.matchId;
      this.$refs.statsTableModalPopupRef.handleOpen();
    },

    isMatchEnded(match) {
      return match.matchState < 0 ? true : false;
    },

    favMatchClassObj(o) {
      // const matchEndedStatus = config.matchEndedStatus;
      let disable = false;
      let selected = o.isFavMatch;

      // @command: if match ended has fav, can unfav, but cannot fav again
      if (this.isLogin && this.isMatchEnded(o) && !o.isFavMatch) {
        disable = true;
      }

      return {
        disable: disable,
        selected: selected,
      };
    },

    async handleFavMatchClick(o, level2, event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.isLogin) {
        // @command: if match ended and isFav, can unFav
        if (this.isMatchEnded(level2) && !level2.isFavMatch) {
          return;
        } else {
          level2.isFavMatch = !level2.isFavMatch;
        }

        let params = {
          matchId: level2.matchId,
        };
        const result = level2.isFavMatch
          ? await this.addFavMatch(params)
          : await this.unFavMatch(params);

        if (result.result.businessCode === -1) {
          level2.isFavMatch
            ? (level2.isFavMatch = false)
            : (level2.isFavMatch = true);
        } else {
          let paramsToastr = {
            isOpen: true,
            msg: this.$i18n.t("MATCH"),
            isAddedFav: level2.isFavMatch,
          };
          // this.getFavMatchListData2()

          // this.getFavMatchListData()
          //update fav list
          if (this.type === "fav") {
            this.updateFavMatchList(level2);
          }

          if (this.type === "homeList") {
            this.updateFav(o, level2, "toFav");
          } else if (this.type === "homeFavList") {
            this.updateFav(o, level2, "toList");
          }

          this.toastrFavChangeEvent(paramsToastr);
        }
      } else {
        if (this.isMobile) {
          this.$refs.PopUpSignInIndexMobileRef.handleOpen();
        } else {
          this.favLoginTipsChangeEvent({
            isOpen: true,
            event: event,
            callBackUrl: this.currentPathName,
          });
        }
      }
    },

    updateFavMatchList(o) {
      let currentMatchList = this.matchList;

      for (let i = 0; i < currentMatchList.length; i++) {
        let level1 = currentMatchList[i].leagueMatchList;

        for (let x = 0; x < level1.length; x++) {
          let level2 = level1[x].matchList;

          for (let y = 0; y < level2.length; y++) {
            if (level2[y].matchId === o.matchId) {
              level2.splice(y, 1);

              if (level2.length === 0) {
                level1.splice(x, 1);

                if (level1.length === 0) {
                  currentMatchList.splice(i, 1);
                  this.$emit("favChangeEmit");
                }
              }
            }
          }
        }
      }
      if (currentMatchList.length === 0) {
        this.isShowNoData = true;
      } else {
        this.isShowNoData = false;
      }
    },
    updateFav(o, level2, to) {
      this.$emit("updateFav", {
        o: o,
        level2: level2,
        to: to,
      });
    },
    updateFavData({ o, level2 }) {
      this.matchList.forEach((a) => {
        let sameCountry = o.countryKey === a.countryKey;
        if (sameCountry) {
          a.matchList.forEach((b) => {
            let sameMatch = level2.matchId === b.matchId;
            if (sameMatch) {
              b.isFavMatch = !b.isFavMatch;
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.home-match-title-fav:hover {
  background-color: transparent;
}
.home-match-country {
  color: var(--color-text-default-secondary);
  font-size: 12px;
  line-height: 140%;
  font-family: var(--weight-400);
}
.phase1-end-column {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.skeleton-match__wrapper {
  width: 100%;
  height: 100%;
  padding: 1rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
}

.skeleton-match__title {
  width: 50%;
  height: 1rem;
  margin-bottom: 0.25rem;
}

.skeleton-match__content {
  width: 100%;
  height: 2rem;
  margin-bottom: 0.5rem;
}

.home-match__win-lose {
  background-color: green;
  border-radius: 50%;
  padding: 0.3rem;
  color: white;
  width: 0.75rem;
  border: 0.1rem solid white;
  height: 0.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5rem;
}

.home-match__win-lose.W {
  background-color: #5cd66c;
}

.home-match__win-lose.L {
  background-color: #cf283e;
}

.home-match__win-lose.D {
  background-color: #ed9c5a;
}

.home-match__status {
  margin-right: 16px;
  margin-left: 5px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* font-size: 0.563rem;
  color: var(--color-grey-light); */

  color: var(--color-text-default-secondary);
  text-align: center;
  margin-bottom: 8px;

  /* Caption Strong */
  font-family: var(--typography-caption-font-family);
  font-size: var(--typography-caption-size-large);
  font-style: normal;
  font-weight: var(--typography-caption-font-weight-strong);
  line-height: normal;
  letter-spacing: 0.2px;
}

.home-match__1-wrapper {
  flex: 1;
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  position: relative;
}
/* .home-match__1-wrapper:after {
  position: absolute;
  top: 45%;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: red;
  display: block;
  transform: translate3d(0, -50%, 0);
  content: "";
} */
.home-match__1-container {
  flex: 1;
  justify-content: space-between;
  /* margin-bottom: 0.2rem; */
}
.home-match__team-name {
  color: var(--color-grey-light);
}
.home-match__date {
  margin-bottom: 0.5rem;
  color: var(--color-text-default-default);

  /* Body Strong */
  font-size: 16px;
  font-style: normal;
  font-family: var(--weight-600);
  line-height: 140%; /* 22.4px */
  letter-spacing: 0.64px;
}
.match-home-content__wrapper .match-wrapper {
  background: var(--color-background-default-secondary);
  padding: 16px;
  border-radius: 16px;
}
.match-wrapper {
  margin-bottom: 16px;
  /* margin-top: 18px;
  margin-bottom: 18px; */
}
.match-wrapper.split {
  background-color: var(--color-background-default-secondary);
  padding: 16px;
  border-radius: 16px;
  box-sizing: border-box;
}
.match-fav-content__wrapper .match-wrapper {
  /* margin-bottom: 0.5rem; */
}
.match-fav-content__wrapper .match-wrapper.last {
  margin-bottom: 0;
}

.match-container {
  display: flex;
  margin-bottom: 0.5rem;
  position: relative;
}

.fav-match-container:last-child {
  margin-bottom: 0;
}
.fav-page-match-container.mb {
  margin-bottom: 0.5rem;
}
.fav-page-match-container.mb:last-child {
  margin-bottom: 0;
}
.fav-page-match-container {
  margin-bottom: 0;
}
.match-container:hover .home-match__score-card__wrapper {
  background-color: var(--color-background-default-tertiary-hover);
}

.match-container:hover .home-match__static-card__wrapper {
  background-color: var(--color-background-default-default-hover);
}

.match-container:hover
  .home-match__actions-card__wrapper
  .home-match__icon-wrapper {
  background-color: var(--color-background-default-default-hover);
}

.home-match__static-card__wrapper {
  background-color: #35454d;
  padding: 0.5rem 0.25rem 0.2rem;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: 6.25rem;
  align-items: center;
}

.home-match__static-card__brief {
  padding: 0.5rem 1.5rem;
}

.home-match__score-card__wrapper {
  display: flex;
  flex-grow: 1;
  background-color: var(--color-theme);
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  width: 35rem;
  padding: 1rem 0 0.5rem;
  border-left: 0.4rem solid transparent;
  border-radius: var(--size-radius-200);
  background: var(--color-background-default-tertiary);
}
.home-match__score-card__wrapper.live-selected {
  position: relative;
}
.home-match__score-card__wrapper.live-selected:after {
  content: "";
  display: block;
  position: absolute;
  left: -7px;
  top: 0;
  width: 5px;
  height: 100%;
  border-radius: 100px 0 0 100px;
  background-color: var(--color-icon-primary-active);
}

.home-match__score-card__wrapper.no-odds-match {
  border-radius: 0.5rem;
}

.home-match__actions-card__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.live-selected {
  /* sample */
  /* border-left: 0.4rem solid var(--color-icon-primary-active); */
}

.match-status__live {
  background-color: #cf283e;
  padding: 0.2rem;
  border-radius: 0.3rem;
  font-size: 10.4px;
}

.match-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.match-detail__status {
  width: 1.6rem;
}

.match-detail__status-w-auto {
  width: auto;
}

.match-detail__score-wrapper {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.match-detail__score-wrapper .score {
  min-width: 1.25rem;
  min-height: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.688rem;
  font-family: var(--weight-700);
}

.match-detail__team-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 15px;
}

.match-detail__name {
  width: 9rem;
  white-space: nowrap;
  overflow: hidden;
  color: var(--color-text-default-default);
  text-align: center;
  text-overflow: ellipsis;

  /* Caption */
  font-family: var(--typography-caption-font-family);
  font-size: var(--typography-body-size-small);
  font-style: normal;
  /* font-family: var(--weight-700); */
  line-height: normal;
  letter-spacing: 0.64px;
  margin-top: 0.375rem;
}

.match-middle {
  flex: 0.5;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.match-middle__seperator {
  margin: 0 0.5rem;
  font-family: var(--weight-700);
}

.match-score-or-time-section {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /* Subheading Strong */
  font-family: var(--typography-heading-font-family);
  font-size: var(--typography-heading-size-extra-small);
  font-style: normal;
  font-family: var(--weight-700);
  line-height: 120%; /* 24px */
  min-width: 97px;
  /* margin-top: 18px; */
  margin-top: -17px;
}
.fav-time-section {
  margin-top: 18px;
}

.match-score-or-time__strikethrough {
  text-decoration: line-through;
}

.match-score-or-time-container {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-text-default-default);
  text-align: center;
  font-size: 24px;
  font-family: var(--weight-600);
}
.match-score-or-time-container-fav {
  margin-top: 7px;
}
.match-score-or-time__pad-for-red-card {
  padding-top: 0.375rem;
}

.match-penalty-score-wrapper {
  color: var(--color-text-default-secondary);
  text-align: center;

  /* Caption Strong */
  font-family: var(--typography-caption-font-family);
  font-size: var(--typography-caption-size-large);
  font-style: normal;
  font-weight: var(--typography-caption-font-weight-strong);
  line-height: normal;
  letter-spacing: 0.2px;
}

.match-penalty-score-separator {
  margin: 0 0.2rem;
}

.league-fav-icon {
  position: relative;
  top: 0.15rem;
  margin-left: 11px;
}

.team-fav-icon-right {
  position: absolute;
  right: -1rem;
  top: 0.375rem;
}
.team-fav-icon-left {
  position: absolute;
  left: -1rem;
  top: 0.375rem;
}

.icon-league {
  position: relative; /*absolute*/
  width: 40px;
  height: 40px;
  /* padding: 2.5px; */
  box-sizing: border-box;
}

.team-red-card-section {
  display: flex;
  justify-content: space-between;
  /* width: 100%; */
  gap: 22px;
}
.team-red-card-container {
  display: flex;
  justify-content: center;
  width: var(--size-icon-medium);
}
.team-red-card {
  background: var(--color-background-error-default);
  width: 0.375rem;
  height: 0.5rem;
  margin-right: 2px;
  border-radius: 1px;
  display: block;
}
.team-red-card:last-child {
  margin-right: 0;
}

.has-subleague-fav {
  margin-right: 0.25rem;
}
.penalty-compact-label {
  border-radius: var(--size-radius-100);
  background: var(--color-background-brand-default);
  padding: 2px 4px;
  font-size: 0.813rem;
  font-family: var(--weight-700);
  color: var(--color-tag-active-text);
  position: absolute;
}
.penalty-compact-label.left {
  top: -0.4rem;
  left: -0.6rem;
}
.penalty-compact-label.right {
  top: -0.4rem;
  right: -0.6rem;
}
.penalty-score {
  border-left: 1px solid var(--color-grey-40);
}
.capitalize {
  text-transform: capitalize;
}
.text-centered {
  text-align: center;
}
.phase1-match-status {
  width: 3.5rem; /* Phase 2-2rem */
  margin: 0 0.5rem; /* Phase 2-0 0.813rem */
}

/*remove on phase 2*/
.home-match__icon-highlight__mobile-phase1 {
  margin: 0 0.5rem !important; /*0 1rem*/
}
.home-match__card-odds-content-phase1 {
  padding: 0.5rem 0 0.5rem 0.1rem !important;
}
/*remove on phase 2*/

.match-table__standings__form-ball {
  color: var(--white-1000);
  width: 25.6px !important;
  height: 25.6px !important;
  min-width: unset;
  border-radius: 50%;
  flex: unset !important;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  position: absolute;
  right: 19.2px;
  top: 50%;
  transform: translate3d(0, -50%, 10px);
  letter-spacing: 0.64px;
  font-family: var(--weight-600);
}
.match-table__score-box:last-child .match-table__standings__form-ball:after {
  width: 10px;
  height: 2px;
  border-radius: 2px;
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  display: block;
  content: "";
  background-color: red;
}

.match-table__standings__form-ball.ball-0,
.match-table__score-box:last-child
  .match-table__standings__form-ball.ball-0:after {
  background-color: var(--success-500);
}
.match-table__standings__form-ball.ball-1,
.match-table__score-box:last-child
  .match-table__standings__form-ball.ball-1:after {
  background-color: var(--gray-500);
}
.match-table__standings__form-ball.ball-2,
.match-table__score-box:last-child
  .match-table__standings__form-ball.ball-2:after {
  background-color: var(--error-500);
}
.home-match-fav-title {
  letter-spacing: 0.64px;
  font-family: var(--weight-600);
  color: var(--color-text-default-default);
  margin-top: 0px;
  margin-bottom: 4px;
}
.home-match-fav-title:hover {
  background-color: transparent;
}
.league-match-container {
  margin-bottom: 8px;
}
.btn-fav-aspn.match-list-fav {
  width: 22.83px;
  height: 21.8px;
}
.btn-fav-aspn.fav-page {
  width: 22.83px;
  height: 21.8px;
}
.btn-fav-wrapper .btn-fav-aspn {
  margin-bottom: 14px;
}
.home-match__league_icon {
  width: 33.33px;
  height: 33.33px;
  margin-right: 8px;
}
.match-wrapper.fav {
  margin-bottom: 0;
  padding-bottom: 0;
  border-radius: 0;
  padding-top: 8px;
}
.match-wrapper.fav:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.match-wrapper.fav.last {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

@media (max-width: 768px) {
  /* for test */
  .btn-fav-aspn-blank {
    width: 20px;
    height: 20px;
  }
  .btn-fav-wrapper .btn-fav-aspn-mobile {
    margin-top: 5px;
  }
  .match-score-or-time-section {
    /* min-width: unset; */
    margin-top: 7px;
  }
  .match-score-or-time-section.has-pen {
    margin-top: 13px;
  }

  .match-detail__team-container {
    margin-top: 9px;
  }
  .home-match__status {
    color: var(--color-text-default-secondary);
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-family: var(--weight-600);
    line-height: 140%; /* 18.2px */
    margin-right: 0;
    margin-left: 15px;
    margin-bottom: 0;
    margin-top: 7px;
    flex-shrink: 0;
  }
  .match-detail {
    flex-grow: 1;
  }
  .match-detail__name {
    font-size: 13px;
    font-weight: var(--weight-medium);
    width: 50%;
  }
  .match-penalty-score-wrapper {
    color: var(--color-text-default-secondary);
    text-align: center;

    font-size: 13px;
    font-style: normal;
    font-family: var(--weight-700);
    line-height: 140%; /* 18.2px */
    letter-spacing: 0.52px;
  }
  .league-fav-icon {
    top: 0.18rem;
  }
  .icon-league {
    width: 36px;
    height: 36px;
    /* padding: 2px; */
    box-sizing: border-box;
  }
  .penalty-team-container {
    margin-top: 15px;
  }

  .home-match__wrapper.fav {
    margin-bottom: 0;
    padding-bottom: 0;
    border-radius: 0;
    padding-top: 4px;
    margin-top: 0;
  }
  .home-match__wrapper.fav:first-child {
    margin-top: 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .home-match__wrapper.league:first-child {
    margin-top: 0;
  }

  .home-match__wrapper.fav.last {
    margin-bottom: 8px;
    padding-bottom: 16px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}

@media (max-width: 400px) {
  .home-match__team-name {
    /* display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical; */
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 9.5rem;
  }
  .home-match__team-name.with-fav-star,
  .home-match__team-name.with-penalty-score {
    max-width: 8.5rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score,
  .home-match__team-name.with-penalty-score.with-penalty-win {
    max-width: 7.5rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score.with-penalty-win {
    max-width: 6.5rem;
  }
}

@media (max-width: 320px) {
  .home-match__team-name {
    max-width: 8rem;
  }
  .home-match__team-name.with-fav-star,
  .home-match__team-name.with-penalty-score {
    max-width: 7rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score,
  .home-match__team-name.with-penalty-score.with-penalty-win {
    max-width: 6rem;
  }
  .home-match__team-name.with-fav-star.with-penalty-score.with-penalty-win {
    max-width: 5rem;
  }
  .btn-fav-aspn-mobile.favpage {
    width: 20px;
    height: 20px;
  }
}
</style>

<style>
@media (max-width: 768px) {
  /* for test */
  .icon-league-fav {
    width: 37px !important;
    height: 37px !important;
  }
  .home-match-fav-title {
    font-size: 16px;
    letter-spacing: 0.64px;
    margin-bottom: 0;
  }
  .mobile-match-card-name {
    gap: 97px;
    /* margin: 0 40px 0 27.77px; */
    margin: 0 44px 0 calc(32px + 15px);
  }
  .mobile-match-card-name .btn-fav-wrapper {
    position: relative;
  }
  .home-match__date {
    margin-top: 8px;
    margin-bottom: 12px !important;
    font-size: 14px !important;
  }
  .match-score-or-time-container {
    min-width: 71px;
  }
}
</style>
